// extracted by mini-css-extract-plugin
module.exports = {"message":"ChatBubble_message__1c_VQ","text":"ChatBubble_text__2b0aX","text_full_screen":"ChatBubble_text_full_screen__3x759"};